import type { FC } from 'react';
import type { InsiderTransation } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';
import { Card } from '@/pages/CompanyReport/components/InsiderTradingTransactions';

export interface CardsProps {
  data: InsiderTransation[];
  handleClick: (index: number) => void;
  active: number[];
}

const Cards: FC<CardsProps> = ({ data, handleClick, active }) => (
  <>
    {data.map((n, i) => (
      <Card
        key={`InsiderTradingAccordionRow-${n.ownerName}-${n.shares}-${i}`}
        index={i}
        open={active.includes(i)}
        onClick={handleClick}
        filingDate={n.filingDate}
        shares={n.shares}
        priceMax={n.priceMax}
        ownerName={n.ownerName}
        boardTitle={n.boardTitle}
        teamTitle={n.teamTitle}
        ownerType={n.ownerType}
        transactionType={n.transactionType}
        transactionValue={n.transactionValue}
      />
    ))}
  </>
);

export default Cards;
